import { addPixelUnit, BrandColors } from '@traba/theme'
import React from 'react'
import styled from 'styled-components'

interface BannerSectionProps {
  backgroundColor?: string
  py?: string | number
  px?: string | number
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

const StyledSection = styled.section<{
  $backgroundColor: string
  $py: string | number
  $px: string | number
}>`
  width: 100%;
  background-color: ${(props) => props.$backgroundColor};
  padding-top: ${(props) => addPixelUnit(props.$py)};
  padding-bottom: ${(props) => addPixelUnit(props.$py)};
  padding-left: ${(props) => addPixelUnit(props.$px)};
  padding-right: ${(props) => addPixelUnit(props.$px)};
`

export function BannerSection({
  backgroundColor = BrandColors.White,
  py = 0,
  px = 0,
  children,
  style,
  className,
}: BannerSectionProps) {
  return (
    <StyledSection
      $backgroundColor={backgroundColor}
      $py={py}
      $px={px}
      style={style}
      className={className}
    >
      {children}
    </StyledSection>
  )
}
